import React from "react";
import { Apple } from "lucide-react";
import { cn } from "@/lib/utils";
import { SsoProviderAlias } from "@/types/sso";

interface ProviderIconProps {
  alias: SsoProviderAlias;
  className?: string;
}

export const ProviderIcon: React.FC<ProviderIconProps> = ({
  alias,
  className,
}) => {
  if (alias === "apple") {
    return (
      <div
        className={cn(
          "size-10 rounded-full bg-foreground text-background flex items-center justify-center shrink-0",
          className,
        )}
        aria-hidden
      >
        <Apple className="size-5" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "size-10 rounded-full bg-muted text-foreground flex items-center justify-center shrink-0 border border-base-border",
        className,
      )}
      aria-hidden
    >
      <span className="text-base font-semibold leading-none">G</span>
    </div>
  );
};
